// Local
import {initUiKit} from "./ui-kit";

window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-block-type="ctc-list"]').forEach(async ($el) => {
        const CtcSlider = await import('./partials/ctc-slider');
        (new CtcSlider.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="brand-character-list"]').forEach(async ($el) => {
        const CharacterList = await import('./partials/character-list');
        (new CharacterList.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="fun-list"]').forEach(async ($el) => {
        const AjaxList = await import('./partials/ajax-list');
        (new AjaxList.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="article-list"]').forEach(async ($el) => {
        const AjaxList = await import('./partials/ajax-list');
        (new AjaxList.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="vacancy-list"]').forEach(async ($el) => {
        const AjaxList = await import('./partials/ajax-list');
        (new AjaxList.default($el));
    });
    $wrapper.querySelectorAll('[data-videoplayer]').forEach(async ($el) => {
        const Videoplayer = await import('./partials/videoplayer');
        (new Videoplayer.default($el));
    });
    $wrapper.querySelectorAll('[data-newsletter-form]').forEach(async ($el) => {
        const Newsletter = await import('./partials/newsletter');
        (new Newsletter.default($el));
    });
    $wrapper.querySelectorAll('[data-sticky-container]').forEach(async ($el) => {
        const StickyContainer = await import('./partials/sticky-container');
        (new StickyContainer.default($el));
    });
    $wrapper.querySelectorAll('.collapsable-trigger').forEach(async ($el) => {
        const InlineCollapsable = await import('./partials/inline-collapsable');
        (new InlineCollapsable.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="quote-list"]').forEach(async ($el) => {
        const QuoteSlider = await import('./partials/quote-slider');
        (new QuoteSlider.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="m-power-block"]').forEach(async ($el) => {
        const MPower = await import('./partials/m-power');
        (new MPower.default($el));
    });
    $wrapper.querySelectorAll('[data-block-type="music-album-list"]').forEach(async ($el) => {
        const AjaxList = await import('./partials/ajax-list');
        (new AjaxList.default($el));
    });
    $wrapper.querySelectorAll('[data-back]').forEach(async ($el) => {
        const BackButton = await import('./partials/back-button');
        (new BackButton.default($el));
    });
    $wrapper.querySelectorAll('[data-hero-slider]').forEach(async ($el) => {
        const HeroSlider = await import('./partials/hero-slider');
        (new HeroSlider.default($el));
    });
    $wrapper.querySelectorAll('[data-href]').forEach(async ($el) => {
        const LinkTo = await import('./partials/link-to');
        (new LinkTo.default($el));
    });
    $wrapper.querySelectorAll('[data-fun-puzzle-wrap]').forEach(async ($el) => {
        const FunPuzzle = await import('./partials/fun-puzzle');
        (new FunPuzzle.default($el));
    });

    // Only apply segment switcher when we have locale in the routing
    if (placeholders.router.locale) {
        $wrapper.querySelectorAll('[data-segment-top-bar]').forEach(async ($el) => {
            const SegmentSwitcher = await import('./partials/segment-switcher');
            (new SegmentSwitcher.default($el));
        });
    }

    /**
     * Wrap videos in reading in video container
     */
    $wrapper.querySelectorAll('.reading iframe[src*="youtube.com"], .reading iframe[data-cmp-src*="youtube.com"]').forEach(($el) => {
        if (!$el.parentElement.classList.contains('.video-container') && !$el.parentElement.classList.contains('.embed-container')) {
            let wrapper = document.createElement('div');
            wrapper.classList.add('video-container')
            $el.parentNode.insertBefore(wrapper, $el);
            wrapper.appendChild($el);
        }
    });

    // Helper to make sure the ui-kit gets initialized in the cms preview
    if (! $wrapper.uiKitInitialized) {
        initUiKit($wrapper);
    }
}

(function() {
    window.initDom(document);
})();